module.exports = __webpack_public_path__ + "static/media/Complementation.172de685.jpg";